module.exports = __webpack_public_path__ + "static/media/gatorProtectBlueShield.c66c9148.png";